import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";


const Country = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    let response33 = useInvoke("WebApps", "33", {});

    useEffect(() => {

        //Get countries
        if (response33.data.payload != undefined) {
            let myData = JSON.parse(response33.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/Country/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[3]}`}},

              ];
              rowsList.push(row);
            });
            setColumns(["Country", "Abbr", "Date Added"]);
            setRows(rowsList);
        }

    }, [response33.data.payload]);

    document.title = "Countries";
    return ( 
        <div className="countries">

            {user["email"] != undefined &&
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Countries</h2>
                        <p><Link className="btn btn-primary" to="/Country/New">New Country</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
        </div>
     );
}
 
export default Country;